import {Component, Input, OnInit} from '@angular/core';
import {IAbout} from 'projects//paid_ukr/src/app/components/about-us/about-us.service';

@Component({
  selector: 'app-about-us-item',
  templateUrl: './about-us-item.component.html',
  styleUrls: ['./about-us-item.component.scss']
})
export class AboutUsItemComponent implements OnInit {

@Input()item: IAbout;
  constructor() { }

  ngOnInit(): void {
  }

}
